import { LicenseEditRequest } from '../models/ss-api/requests/license.edit.request';
import { License, LicenseStatusTypes } from '../models/domain/license';
import { Input } from '@angular/core';
import { ManagerBase } from './manager.base';
import { LicenseFullResponse } from '../models/ss-api/responses/license.full.response';

import { ProductArray, Product } from '../models/domain/product';
import { LicenseDetailsDialog } from '../dialogs/license.details/license.details.dialog';
import { PoolStudioSettingsGroupArray } from '../models/domain/poolstudio.settings.group';
import { BillingCycleTypes } from '../models/domain/invoice';
import * as moment from 'moment';
import { DialogOptions } from '../services/modal-dialogs';

export class LicenseManager extends ManagerBase<LicenseFullResponse> {

    constructor(input: string = null, showAfterLoad: boolean = false) {
        super();

        if (Input != null)
            this.Load(input, showAfterLoad);
    }

    public License(): License {
        if (this.newEntity) {
            return this.newEntity.License;
        } else {
            return new License();
        }
    }

    public AvailableProdutcs(): ProductArray {
        if (this.newEntity == undefined ||
            this.newEntity.AvailableProducts == undefined ||
            this.newEntity.AvailableProducts.length == 0)
            return new ProductArray();
        else {
            return this.newEntity.AvailableProducts;
        }
    }

    public AvailablePoolStudioSettingsGroups(): PoolStudioSettingsGroupArray {

        if (this.newEntity == undefined ||
            this.newEntity.AvailablePoolStudioSettingsGroups == undefined ||
            this.newEntity.AvailablePoolStudioSettingsGroups.length == 0)
            return new PoolStudioSettingsGroupArray();
        else
            return this.newEntity.AvailablePoolStudioSettingsGroups;
    }

    public OriginalProduct(): Product {
        this.newEntity.AvailableProducts.forEach(product => {
            if (this.original.License.ProductID == product.ID)
                return product;
        });

        // error
        return new Product();
    }

    public Product(): Product {

        for (let product of this.AvailableProdutcs()) {
            if (this.original.License.ProductID == product.ID)
                return product;
        }

        // error
        return new Product();
    }

    public SalesRepresentativeIDEdited(): boolean {
        return this.original.License.SalesRepresentativeID != this.newEntity.License.SalesRepresentativeID;
    }

    public StatusEdited(): boolean {
        if (this.original) {
            return this.original.License.Status != this.newEntity.License.Status;
        } else {
            return false;
        }
    }

    public StatusDisabledReasonEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.StatusDisabledReason != this.newEntity.License.StatusDisabledReason;
    }

    public PackageTypeEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        // return this.original.License.PackageType != this.newEntity.License.PackageType;
        return this.original.License.ProductID != this.newEntity.License.ProductID;
    }

    public PreventV3InstallEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.PreventV3Install != this.newEntity.License.PreventV3Install;
    }

    public IgnoreHardwareCheckEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.IgnoreHardwareCheck != this.newEntity.License.IgnoreHardwareCheck;
    }

    public TransferDisabledEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.TransferDisabled != this.newEntity.License.TransferDisabled;
    }


    public TransferDisabledReasonEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.TransferDisabledReason != this.newEntity.License.TransferDisabledReason;
    }

    public TransferLimitMaxEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.TransferLimitMax != this.newEntity.License.TransferLimitMax;
    }

    public TransferLimitInTimeMinutesEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.TransferLimitInTimeMinutes != this.newEntity.License.TransferLimitInTimeMinutes;
    }

    public SoftwareVersionLockEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.SoftwareVersionLock != this.newEntity.License.SoftwareVersionLock;
    }

    public SoftwareVersionLockReasonEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.SoftwareVersionLockReason != this.newEntity.License.SoftwareVersionLockReason;
    }

    public NextBillingDateEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.NextBillingDate != this.newEntity.License.NextBillingDate;
    }

    public TOSWindowContinueUntilDateEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.TOSWindowContinueUntilDate != this.newEntity.License.TOSWindowContinueUntilDate;
    }

    public ProductRecurringAmountEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.ProductRecurringAmount != this.newEntity.License.ProductRecurringAmount;
    }

    public AddOnPricingDetailsEdited(): boolean {
        if (!this.original || !this.newEntity) return false;

        const original = this.original.License.AddOnPricingDetails;
        const current  = this.newEntity.License.AddOnPricingDetails;

        if (!original || !current) return false;

        return current.some(addOn =>
            original.find(o => o.AddOnID === addOn.AddOnID)!
                .ProductRecurringAmount !== addOn.ProductRecurringAmount
        );
    }    

    public YardRecurringAmountEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.YardRecurringAmount != this.newEntity.License.YardRecurringAmount;
    }

    public PaymentMethodEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.PaymentMethod != this.newEntity.License.PaymentMethod;
    }

    public BillingCycleEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.BillingCycle != this.newEntity.License.BillingCycle;
    }

    public PoolStudioSettingsGroupEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.AssignedPoolStudioSettingsGroup != this.newEntity.License.AssignedPoolStudioSettingsGroup;
    }

    public DontSendManualCancellationEmailEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.DontSendManualCancellationEmail != this.newEntity.License.DontSendManualCancellationEmail;
    }

    public TOSWindowEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.TOSWindow != this.newEntity.License.TOSWindow;
    }

    public CancellationReasonEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.CancellationReason != this.newEntity.License.CancellationReason;
    }

    public TerminationDateEdited(): boolean {
        if (!this.original || !this.newEntity) return false;

        // if (this.newEntity.License.Status != LicenseStatusTypes.Cancelled)
        //     return false;

        return moment(this.original.License.TerminationDate).format('YYYY-MM-DD') != moment(this.newEntity.License.TerminationDate).format('YYYY-MM-DD');
    }

    public DefaultClientSettingsEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.OverrideUpdaterClientSettings_ID != this.newEntity.License.OverrideUpdaterClientSettings_ID;
    }

    public UpdateVersionForceGroupIDEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.UpdateVersionForceGroupID != this.newEntity.License.UpdateVersionForceGroupID;
    }

    public UpdaterV3VersionForceGroupIDEdited(): boolean {
        if (!this.original || !this.newEntity) return false;
        return this.original.License.UpdaterV3VersionForceGroupID != this.newEntity.License.UpdaterV3VersionForceGroupID;
    }
 

    public Edited(): boolean {

        // first one we try to make sure we are not null or undefined

        if (this.StatusEdited())
            return true;

        if (this.DontSendManualCancellationEmailEdited())
            return true;

        if (this.TOSWindowEdited())
            return true;

        if (this.SalesRepresentativeIDEdited())
            return true;

        if (this.StatusDisabledReasonEdited())
            return true;

        if (this.PackageTypeEdited())
            return true;

        if (this.PreventV3InstallEdited())
            return true;

        if (this.IgnoreHardwareCheckEdited())
            return true;

        if (this.TransferDisabledEdited())
            return true;

        if (this.TransferDisabledReasonEdited())
            return true;

        if (this.TransferLimitMaxEdited())
            return true;

        if (this.TransferLimitInTimeMinutesEdited())
            return true;

        if (this.SoftwareVersionLockEdited())
            return true;

        if (this.SoftwareVersionLockReasonEdited())
            return true;

        if (this.NextBillingDateEdited())
            return true;

        if (this.TOSWindowContinueUntilDateEdited())
            return true;

        if (this.ProductRecurringAmountEdited())
            return true;

        if (this.AddOnPricingDetailsEdited())
            return true;

        if (this.YardRecurringAmountEdited())
            return true;

        if (this.PaymentMethodEdited())
            return true;

        if (this.PoolStudioSettingsGroupEdited())
            return true;

        if (this.CancellationReasonEdited())
            return true;

        if (this.TerminationDateEdited())
            return true;

        if (this.DefaultClientSettingsEdited()) {
            return true;
        }

        if (this.UpdateVersionForceGroupIDEdited()) {
            return true;
        }

        if (this.UpdaterV3VersionForceGroupIDEdited()){
            return true;
        }

        // not edited
        return false;

    }


    Load(input: string, showAfterLoad: boolean = true) {

        if (input == null)
            return;

        this.LoadAction = this.api.LicenseFull(input);

        let DataLoaded = this.OnDataLoaded.subscribe(() => {
            DataLoaded.unsubscribe();
            this.CloneDateFix();

            if (showAfterLoad) {
                let options: DialogOptions = {
                    width: 1200,
                    height: 800
                };
                this.DialogAction = this.dialogService.addDialog(LicenseDetailsDialog, {
                    licenseManager: this
                }, options);
            }

        });

        this.LoadBase();
    }


    private CloneDateFix(): void {

        // dates don't convert as dates so do it manyally
        this.original.License.NextBillingDate = this.newEntity.License.NextBillingDate;
        this.original.License.TerminationDate = this.newEntity.License.TerminationDate;

    }


    public SaveChanges(confirm: boolean = true, showResult: boolean = true, editNote: string = '') {

        if (this.Edited() == false)
            return;

        let request = this.GetLicenseEditRequest();
        request.Note = editNote;
        this.SaveAction = this.api.LicenseEdit(request);

        this.SaveChangesBase();
    }

    private GetLicenseEditRequest(): LicenseEditRequest {


        let request = new LicenseEditRequest();
        request.ID = this.newEntity.License.ID;

        if (this.StatusEdited() || this.original.License.Status == LicenseStatusTypes.Cancelled) {
            request.Status = this.StatusEdited() ? this.newEntity.License.Status : this.original.License.Status;

            if (request.Status == LicenseStatusTypes.Cancelled) {
                if (this.TerminationDateEdited())
                    request.TerminationDate = this.newEntity.License.TerminationDate;
                else
                    request.TerminationDate = null;
            }
        } else
            request.Status = null;

        if (this.SalesRepresentativeIDEdited())
            request.SalesRepresentativeID = this.newEntity.License.SalesRepresentativeID;
        else
            request.SalesRepresentativeID = null;

        if (this.DontSendManualCancellationEmailEdited())
            request.DontSendManualCancellationEmail = this.newEntity.License.DontSendManualCancellationEmail;
        else
            request.DontSendManualCancellationEmail = null;

        if (this.TOSWindowEdited())
            request.TOSWindow = this.newEntity.License.TOSWindow;
        else
            request.TOSWindow = null;  

        if (this.ProductRecurringAmountEdited())
            request.ProductRecurringAmount = this.newEntity.License.ProductRecurringAmount;
        else
            request.ProductRecurringAmount = null;

        if (this.AddOnPricingDetailsEdited())
            request.AddOnPricingDetails = this.newEntity.License.AddOnPricingDetails;
        else
            request.AddOnPricingDetails = null;

        if (this.YardRecurringAmountEdited())
            request.YardRecurringAmount = this.newEntity.License.YardRecurringAmount;
        else
            request.YardRecurringAmount = null;

        if (this.StatusDisabledReasonEdited())
            request.StatusDisabledReason = this.newEntity.License.StatusDisabledReason;
        else
            request.StatusDisabledReason = null;

        if (this.PackageTypeEdited()) {
            // request.PackageType = this.newEntity.License.PackageType;
            request.ProductID = this.newEntity.License.ProductID;
        } else {
            // request.PackageType = null;
            request.ProductID = null;
        }


        if (this.TransferDisabledEdited())
            request.TransferDisabled = this.newEntity.License.TransferDisabled;
        else
            request.TransferDisabled = null;


        if (this.PreventV3InstallEdited())
            request.PreventV3Install = this.newEntity.License.PreventV3Install;
        else
            request.PreventV3Install = null;


        if (this.IgnoreHardwareCheckEdited())
            request.IgnoreHardwareCheck = this.newEntity.License.IgnoreHardwareCheck;
        else
            request.IgnoreHardwareCheck = null;

        if (this.TransferDisabledReasonEdited())
            request.TransferDisabledReason = this.newEntity.License.TransferDisabledReason;
        else
            request.TransferDisabledReason = null;


        if (this.TransferLimitMaxEdited())
            request.TransferLimitMax = this.newEntity.License.TransferLimitMax;
        else
            request.TransferLimitMax = null;


        if (this.TransferLimitInTimeMinutesEdited())
            request.TransferLimitInTimeMinutes = this.newEntity.License.TransferLimitInTimeMinutes;
        else
            request.TransferLimitInTimeMinutes = null;


        if (this.SoftwareVersionLockEdited())
            request.SoftwareVersionLock = this.newEntity.License.SoftwareVersionLock;
        else
            request.SoftwareVersionLock = null;


        if (this.SoftwareVersionLockReasonEdited())
            request.SoftwareVersionLockReason = this.newEntity.License.SoftwareVersionLockReason;
        else
            request.SoftwareVersionLockReason = null;


        if (this.NextBillingDateEdited())
            request.NextBillingDate = this.newEntity.License.NextBillingDate;
        else
            request.NextBillingDate = null;

        if (this.TOSWindowContinueUntilDateEdited())
            request.TOSWindowContinueUntilDate = this.newEntity.License.TOSWindowContinueUntilDate;
        else
            request.TOSWindowContinueUntilDate = null
        
        if (this.PoolStudioSettingsGroupEdited())
            request.PoolStudioSettingsGroup = this.newEntity.License.AssignedPoolStudioSettingsGroup;
        else
            request.PoolStudioSettingsGroup = 0;

        if (this.BillingCycleEdited())
            request.BillingCycle = this.newEntity.License.BillingCycle;
        else
            request.BillingCycle = BillingCycleTypes.NotDefined;

        if (this.CancellationReasonEdited())
            request.CancellationReason = this.newEntity.License.CancellationReason;
        else
            request.CancellationReason = null;

        if (this.DefaultClientSettingsEdited())
            request.OverrideUpdaterClientSettings_ID = this.newEntity.License.OverrideUpdaterClientSettings_ID;
        else
            request.OverrideUpdaterClientSettings_ID = null;


        if (this.UpdateVersionForceGroupIDEdited())
            request.UpdateVersionForceGroupID = this.newEntity.License.UpdateVersionForceGroupID;
        else
            request.UpdateVersionForceGroupID = null;


        if (this.UpdaterV3VersionForceGroupIDEdited())
                request.UpdaterV3VersionForceGroupID = this.newEntity.License.UpdaterV3VersionForceGroupID;
            else
                request.UpdaterV3VersionForceGroupID = null;
            
        if (this.TerminationDateEdited())
            request.TerminationDate = this.newEntity.License.TerminationDate;
        else
            request.TerminationDate = null;

        return request;

    }

}
